
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2613',
  depVersions: {
  "customer-portal-app": "static-1.2613",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9767",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25671",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5696",
  "hs-test-utils": "static-1.8123",
  "hub-http": "static-1.6326",
  "hub-http-shared-msw-handlers": "static-1.10210",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18508",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11578",
  "I18n": "static-7.1636",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6563",
  "payment-link-components": "static-1.23776",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7160",
  "quartz-core": "static-1.6379",
  "quartz-i18n": "static-1.835",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10313",
  "react-dlb": "static-1.81",
  "react-utils": "static-2.5419",
  "rich-text-lib": "static-1.20005",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18136",
  "ui-components-test-utils": "static-1.5715",
  "UIComponents": "static-3.8524",
  "foundations-assets": "static-1.4976",
  "foundations-components": "static-1.8133",
  "foundations-theming": "static-1.4534",
  "foundations-theming-specialty": "static-1.2250",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1155",
  "quartz-config": "static-1.938",
  "quartz-routing": "static-1.590",
  "quick-fetch": "static-1.3994",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16787",
  "rpc-client-utils": "static-1.4758",
  "sanitize-text": "static-1.8249",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4865",
  "ui-addon-react-router-dom": "static-1.9643",
  "usage-tracker": "static-1.7453",
  "usage-tracker-anonymous": "static-1.5870",
  "usage-tracker-core": "static-1.7303",
  "video-components-external": "static-1.11603",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3474",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3437",
  "quartz-webpack": "static-1.3384",
  "bend-plugin-quartz-routing": "static-1.238",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7784",
  "frontend-preferences-client": "static-1.8031",
  "laboratory-lib": "static-3.7257",
  "onboarding-scopes": "static-1.6564",
  "seat-types-lib": "static-1.247",
  "ui-addon-opt": "static-4.8465",
  "HeadJS": "static-2.767",
  "hs-test-utils-bend-plugin": "static-1.3234",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.159",
  "ts-schema": "static-1.4157",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7914",
  "cssUtils": "static-1.822",
  "customer-data-ui-utilities": "static-1.9930",
  "HubStyle": "static-2.11885",
  "knowledge-content-types": "static-1.8559",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.489",
  "ui-addon-emoji-picker": "static-1.9991",
  "ui-addon-i18n": "static-1.11254",
  "ui-business-units-lib": "static-1.9166",
  "ui-shepherd-react": "static-3.10328",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4431",
  "commerce-tours-lib": "static-1.6284",
  "customer-data-properties": "static-1.51920",
  "getting-started-shared-tasks": "static-1.18689",
  "growth-onboarding-reliability": "static-1.5186",
  "onboarding-tours": "static-1.16791",
  "reference-resolvers-lite": "static-1.8202",
  "sales-checkout-service-client": "static-1.3696",
  "ui-addon-iframeable": "static-1.9169",
  "user-context": "static-1.5215",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.843",
  "hubspotter-http": "static-1.4728",
  "icons": "static-2.653",
  "mobile-manifest-mixins": "static-1.542",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.835",
  "quartz-head": "static-1.825",
  "quartz-test": "static-1.835",
  "quartz-tracking": "static-1.539",
  "trellis-components": "static-1.2199",
  "ui-fonts": "static-1.840",
  "usage-tracker-container": "static-1.7443",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9527",
  "data-token-picker": "static-1.16584",
  "FileManagerLib": "static-1.39531",
  "property-translator": "static-1.5502",
  "atom": "static-1.5179",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6072",
  "salesImages": "static-1.527",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5616",
  "react-create-root-preference": "static-1.34",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1179",
  "bend-plugin-foundations-components": "static-1.4402",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "trellis-assets": "static-1.2180",
  "bend-plugin-foundations-theming": "static-1.3017",
  "foundations-theming-base": "static-1.3519",
  "stylex": "static-1.34",
  "interframe": "static-3.4865",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5867",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.168",
  "chirp-fetch": "static-1.1991",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4581",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4757",
  "content-media-composition-data-lib": "static-1.12631",
  "content-media-compositions": "static-2.16638",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4256",
  "magpie-lib": "static-1.5620",
  "magpie-types": "static-1.5080",
  "media-bridge-lib": "static-1.19100",
  "video-data-lib": "static-1.35261",
  "bender-build-tools": "static-1.3281",
  "inbound-db-properties-service-client": "static-1.3922",
  "superstore": "static-1.4865",
  "feedback-loader": "static-1.29482",
  "ai-components-ui-library": "static-1.9205",
  "ui-addon-video-player": "static-1.8808",
  "ui-coaching-tips": "static-1.28839",
  "sassPrefix": "static-1.158",
  "react-dnd-compat": "static-1.4720",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2602",
  "navigation-messaging": "static-1.7589",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8278",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9913",
  "crm-message-bus": "static-1.43238",
  "growth-data-modal": "static-1.5589",
  "hubspot-apollo-client": "static-1.4983",
  "onboarding-tours-client": "static-1.5005",
  "calling-global-api": "static-1.64857",
  "calling-internal-common": "static-1.31415",
  "calling-lifecycle-internal": "static-1.66239",
  "calling-lifecycle-messages": "static-1.58533",
  "conditional-properties-service-client": "static-1.3873",
  "crm-links": "static-1.6411",
  "crm-pipelines-api-client-types": "static-1.4215",
  "customer-data-objects-ui-components": "static-1.13134",
  "customer-data-properties-shared-msw-handlers": "static-1.9537",
  "customer-data-property-utils": "static-1.8200",
  "external-options-client-types": "static-1.4206",
  "file-manager-components": "static-1.23891",
  "framework-data-schema-resolvers": "static-1.6994",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.278",
  "inbound-db-meta-service-client": "static-1.3663",
  "inbounddb-objects-service-types": "static-1.4294",
  "meetings-icalendar-utils-lib": "static-1.739",
  "multi-currency-client-types": "static-1.3767",
  "object-builder-ui-client": "static-1.49089",
  "pipeline-validation-client-types": "static-1.4043",
  "property-value-citations": "static-1.2534",
  "pulse": "static-1.700",
  "smart-property-lib": "static-1.7722",
  "tiered-pricing": "static-1.1463",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11094",
  "growth-onboarding-confetti": "static-1.3170",
  "growth-onboarding-next-action-utils": "static-1.2211",
  "navigation-components": "static-1.18262",
  "onboarding-tours-utils": "static-1.857",
  "ui-shepherd-tracker": "static-1.7709",
  "ui-universal-auth": "static-1.9100",
  "batch-promise": "static-1.1646",
  "getting-started-shared-tasks-store": "static-1.17807",
  "hubspotter-http-shared-msw-handlers": "static-1.10208",
  "usage-tracker-session-replay": "static-1.5139",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1046",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.6071",
  "FileManagerCore": "static-1.39390",
  "FileManagerImages": "static-1.37042",
  "video-components": "static-1.13605",
  "foundations-components-legacy": "static-1.1158",
  "purchase-motions-api": "static-1.6075",
  "signup-constants": "static-1.19077",
  "signup-ui-url-generator": "static-2.8161",
  "usage-tracker-public": "static-1.7264",
  "reactive-lib": "static-1.830",
  "simple-logging-lib": "static-1.3155",
  "chatspot-core": "static-1.21772",
  "ContentUtils": "static-1.68647",
  "copilot-toolkit": "static-1.11392",
  "growth-onboarding-feedback-components": "static-1.6684",
  "commerce-permissions": "static-1.882",
  "customer-data-tracking": "static-1.6994",
  "products-iframe-lib": "static-1.8212",
  "products-ui-components-shared-msw-handlers": "static-1.10592",
  "restore-request-side-panel-lib": "static-1.1130",
  "onboarding-data-sync-lib": "static-1.2134",
  "hubspot-apollo-cache": "static-1.442",
  "calling-error-reporting": "static-1.31422",
  "shared-worker-versioning": "static-1.11140",
  "calling-usage-tracker": "static-1.6648",
  "voice-sms-access-library": "static-1.1393",
  "conversations-skeleton-state": "static-1.7353",
  "location-customization-utils-lib": "static-1.9552",
  "fdsr-migration-layer": "static-1.113",
  "framework-builder-read-service-client": "static-1.4081",
  "framework-data-schema-quick-fetch": "static-1.6899",
  "persist-promise": "static-1.3803",
  "event-emitter": "static-1.1055",
  "bend-plugin-pulse": "static-1.203",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.359",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10293",
  "fsm": "static-1.3834",
  "policy-lib": "static-1.6886",
  "react-tinymce": "static-1.55508",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10356",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54634",
  "tinymce-plugins": "static-1.57748",
  "tinymce-themes": "static-1.56604",
  "growth-onboarding-next-action-components": "static-1.2239",
  "user-context-client": "static-1.4686",
  "nest": "static-1.337",
  "unified-auth-core-lib": "static-1.896",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4641",
  "video-embed": "static-1.36095",
  "content-icons-ui": "static-1.2256",
  "social-insights-client-types": "static-1.22319",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4918",
  "integrations-lib": "static-1.16481",
  "underscore": "static-1.8",
  "breeze-engine-lib": "static-1.1062",
  "sales-views-client-types": "static-1.4360",
  "InboxConnectUtils": "static-4.15075",
  "meetings-connect-utils-lib": "static-1.7709",
  "calling-orchestration-schema": "static-1.36170",
  "crm-record-cards-service-types": "static-1.3666",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4617",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3147",
  "tinymce-data": "static-1.40719",
  "ui-addon-sales-email": "static-1.5315",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12638",
  "layout-dnd-utils": "static-1.11613",
  "react-codemirror": "static-1.10732",
  "ui-brand-identity-lib": "static-1.15635",
  "NamespacedHubStyle": "static-2.9133",
  "outpost": "static-1.4275",
  "flux-actions": "static-1.345",
  "integrations-error-boundary-lib": "static-1.13896",
  "integrations-tracking-lib": "static-1.5710",
  "native-integrations-shared-strings": "static-1.7888",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10467",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.614",
  "breeze-engine-core": "static-1.340",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68722",
  "layout-data-lib": "static-1.9938",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3122",
  "ads-unified-auth-lib": "static-1.322",
  "google-sheets-integration-lib": "static-1.530",
  "microsoft-drive-integration-lib": "static-1.666",
  "slack-ui-library": "static-1.10498",
  "advanced-menus-core": "static-1.15291",
  "advanced-menus-lib": "static-1.12205",
  "ExportDialog": "static-6.10484",
  "ui-memberships-settings-lib": "static-1.34316",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15290",
  "simple-menus-lib": "static-1.16807"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2613",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9767",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25671",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5696",
  "hs-test-utils": "/hs-test-utils/static-1.8123",
  "hub-http": "/hub-http/static-1.6326",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10210",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18508",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11578",
  "I18n": "/I18n/static-7.1636",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6563",
  "payment-link-components": "/payment-link-components/static-1.23776",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7160",
  "quartz-core": "/quartz-core/static-1.6379",
  "quartz-i18n": "/quartz-i18n/static-1.835",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10313",
  "react-dlb": "/react-dlb/static-1.81",
  "react-utils": "/react-utils/static-2.5419",
  "rich-text-lib": "/rich-text-lib/static-1.20005",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18136",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5715",
  "UIComponents": "/UIComponents/static-3.8524",
  "foundations-assets": "/foundations-assets/static-1.4976",
  "foundations-components": "/foundations-components/static-1.8133",
  "foundations-theming": "/foundations-theming/static-1.4534",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2250",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1155",
  "quartz-config": "/quartz-config/static-1.938",
  "quartz-routing": "/quartz-routing/static-1.590",
  "quick-fetch": "/quick-fetch/static-1.3994",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16787",
  "rpc-client-utils": "/rpc-client-utils/static-1.4758",
  "sanitize-text": "/sanitize-text/static-1.8249",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4865",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9643",
  "usage-tracker": "/usage-tracker/static-1.7453",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5870",
  "usage-tracker-core": "/usage-tracker-core/static-1.7303",
  "video-components-external": "/video-components-external/static-1.11603",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3474",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3437",
  "quartz-webpack": "/quartz-webpack/static-1.3384",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.238",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7784",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8031",
  "laboratory-lib": "/laboratory-lib/static-3.7257",
  "onboarding-scopes": "/onboarding-scopes/static-1.6564",
  "seat-types-lib": "/seat-types-lib/static-1.247",
  "ui-addon-opt": "/ui-addon-opt/static-4.8465",
  "HeadJS": "/HeadJS/static-2.767",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3234",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.159",
  "ts-schema": "/ts-schema/static-1.4157",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7914",
  "cssUtils": "/cssUtils/static-1.822",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9930",
  "HubStyle": "/HubStyle/static-2.11885",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9991",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11254",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9166",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10328",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4431",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6284",
  "customer-data-properties": "/customer-data-properties/static-1.51920",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18689",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5186",
  "onboarding-tours": "/onboarding-tours/static-1.16791",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8202",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3696",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9169",
  "user-context": "/user-context/static-1.5215",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.843",
  "hubspotter-http": "/hubspotter-http/static-1.4728",
  "icons": "/icons/static-2.653",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.542",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.835",
  "quartz-head": "/quartz-head/static-1.825",
  "quartz-test": "/quartz-test/static-1.835",
  "quartz-tracking": "/quartz-tracking/static-1.539",
  "trellis-components": "/trellis-components/static-1.2199",
  "ui-fonts": "/ui-fonts/static-1.840",
  "usage-tracker-container": "/usage-tracker-container/static-1.7443",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9527",
  "data-token-picker": "/data-token-picker/static-1.16584",
  "FileManagerLib": "/FileManagerLib/static-1.39531",
  "property-translator": "/property-translator/static-1.5502",
  "atom": "/atom/static-1.5179",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6072",
  "salesImages": "/salesImages/static-1.527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5616",
  "react-create-root-preference": "/react-create-root-preference/static-1.34",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1179",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4402",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.2180",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3017",
  "foundations-theming-base": "/foundations-theming-base/static-1.3519",
  "stylex": "/stylex/static-1.34",
  "interframe": "/interframe/static-3.4865",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5867",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.168",
  "chirp-fetch": "/chirp-fetch/static-1.1991",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4581",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4757",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12631",
  "content-media-compositions": "/content-media-compositions/static-2.16638",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4256",
  "magpie-lib": "/magpie-lib/static-1.5620",
  "magpie-types": "/magpie-types/static-1.5080",
  "media-bridge-lib": "/media-bridge-lib/static-1.19100",
  "video-data-lib": "/video-data-lib/static-1.35261",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3922",
  "superstore": "/superstore/static-1.4865",
  "feedback-loader": "/feedback-loader/static-1.29482",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9205",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8808",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28839",
  "sassPrefix": "/sassPrefix/static-1.158",
  "react-dnd-compat": "/react-dnd-compat/static-1.4720",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2602",
  "navigation-messaging": "/navigation-messaging/static-1.7589",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8278",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9913",
  "crm-message-bus": "/crm-message-bus/static-1.43238",
  "growth-data-modal": "/growth-data-modal/static-1.5589",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4983",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5005",
  "calling-global-api": "/calling-global-api/static-1.64857",
  "calling-internal-common": "/calling-internal-common/static-1.31415",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66239",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58533",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3873",
  "crm-links": "/crm-links/static-1.6411",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4215",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13134",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9537",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8200",
  "external-options-client-types": "/external-options-client-types/static-1.4206",
  "file-manager-components": "/file-manager-components/static-1.23891",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6994",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.278",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3663",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4294",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.739",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3767",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49089",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4043",
  "property-value-citations": "/property-value-citations/static-1.2534",
  "pulse": "/pulse/static-1.700",
  "smart-property-lib": "/smart-property-lib/static-1.7722",
  "tiered-pricing": "/tiered-pricing/static-1.1463",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11094",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3170",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2211",
  "navigation-components": "/navigation-components/static-1.18262",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.857",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7709",
  "ui-universal-auth": "/ui-universal-auth/static-1.9100",
  "batch-promise": "/batch-promise/static-1.1646",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17807",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10208",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5139",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1046",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.6071",
  "FileManagerCore": "/FileManagerCore/static-1.39390",
  "FileManagerImages": "/FileManagerImages/static-1.37042",
  "video-components": "/video-components/static-1.13605",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1158",
  "purchase-motions-api": "/purchase-motions-api/static-1.6075",
  "signup-constants": "/signup-constants/static-1.19077",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8161",
  "usage-tracker-public": "/usage-tracker-public/static-1.7264",
  "reactive-lib": "/reactive-lib/static-1.830",
  "simple-logging-lib": "/simple-logging-lib/static-1.3155",
  "chatspot-core": "/chatspot-core/static-1.21772",
  "ContentUtils": "/ContentUtils/static-1.68647",
  "copilot-toolkit": "/copilot-toolkit/static-1.11392",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6684",
  "commerce-permissions": "/commerce-permissions/static-1.882",
  "customer-data-tracking": "/customer-data-tracking/static-1.6994",
  "products-iframe-lib": "/products-iframe-lib/static-1.8212",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10592",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1130",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2134",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.442",
  "calling-error-reporting": "/calling-error-reporting/static-1.31422",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11140",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6648",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1393",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7353",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9552",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.113",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4081",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6899",
  "persist-promise": "/persist-promise/static-1.3803",
  "event-emitter": "/event-emitter/static-1.1055",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.203",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.359",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10293",
  "fsm": "/fsm/static-1.3834",
  "policy-lib": "/policy-lib/static-1.6886",
  "react-tinymce": "/react-tinymce/static-1.55508",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10356",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54634",
  "tinymce-plugins": "/tinymce-plugins/static-1.57748",
  "tinymce-themes": "/tinymce-themes/static-1.56604",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2239",
  "user-context-client": "/user-context-client/static-1.4686",
  "nest": "/nest/static-1.337",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.896",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4641",
  "video-embed": "/video-embed/static-1.36095",
  "content-icons-ui": "/content-icons-ui/static-1.2256",
  "social-insights-client-types": "/social-insights-client-types/static-1.22319",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4918",
  "integrations-lib": "/integrations-lib/static-1.16481",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1062",
  "sales-views-client-types": "/sales-views-client-types/static-1.4360",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15075",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7709",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36170",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3666",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4617",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3147",
  "tinymce-data": "/tinymce-data/static-1.40719",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5315",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12638",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11613",
  "react-codemirror": "/react-codemirror/static-1.10732",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15635",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9133",
  "outpost": "/outpost/static-1.4275",
  "flux-actions": "/flux-actions/static-1.345",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13896",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5710",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7888",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10467",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.614",
  "breeze-engine-core": "/breeze-engine-core/static-1.340",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68722",
  "layout-data-lib": "/layout-data-lib/static-1.9938",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3122",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.322",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.530",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.666",
  "slack-ui-library": "/slack-ui-library/static-1.10498",
  "advanced-menus-core": "/advanced-menus-core/static-1.15291",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12205",
  "ExportDialog": "/ExportDialog/static-6.10484",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34316",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15290",
  "simple-menus-lib": "/simple-menus-lib/static-1.16807"
}
};
